// JS actulaiza datos de el carrito de compras y agrega propiedades

js_cart_checkout()
function js_cart_checkout(){
    document.addEventListener('DOMContentLoaded', cartCheckout)
}

function cartCheckout() {
    const buttons = document.querySelectorAll('.js-cart-checkout')

    if (buttons != null) {
        buttons.forEach(button => {
            
            button.addEventListener('click', e => {
                e.preventDefault()

                const attributes = document.querySelector('.js-cart-checkout__attributes')
                const note = document.querySelector('.js-cart-checkout__note')
                
                let value_self = '' 
                let note_self = ''

                note_self = note.value
                
                if (attributes.checked == true) {
                    value_self = attributes.value
                }
                
                actualizarAttributes(value_self, note_self)
            })
            
        })
    }

    function actualizarAttributes(value_self, note_self){

        $.ajax({
            url: "/cart/update.js",
            type: "post",
            data: {
                attributes: {'EXTRA': value_self},
                note: note_self
            },
            dataType: 'json',
            async: false,
            success: res => {
                localStorage.setItem('atom_cart', JSON.stringify(res))
                window.location = '/checkout'
            },
            error: err => {
                console.log(err)
            }
        }) 
    }
}
